import { render, staticRenderFns } from "./ChessboardToolbar.vue?vue&type=template&id=61633e0c&scoped=true"
import script from "./ChessboardToolbar.vue?vue&type=script&lang=js"
export * from "./ChessboardToolbar.vue?vue&type=script&lang=js"
import style0 from "./ChessboardToolbar.vue?vue&type=style&index=0&id=61633e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61633e0c",
  null
  
)

export default component.exports